import { Injectable, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, CanActivate , ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class BlockNavigationGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) { 
    const mdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
    const user = JSON.parse(sessionStorage.getItem('user'));
    let blocknavigation;
    if(mdmDetails) { 
      if (mdmDetails.productCode === 'ADDPMDM') {
        this.router.navigate(['/home']);
      } else if(user.user.fanSignedUpStatus === 'NONE'){ 
        if (mdmDetails.productCode === 'ADDPMDM') {
          this.router.navigate(['/home']);
        } else {
          blocknavigation = [''];
        }
      } else{ 
            if( mdmDetails.productCode === 'ADDPZTE' ){ 
                blocknavigation = ['/signupsetup'];
            } else {
                blocknavigation = ['/productselection', '/signupsetup'];
            }
      }
    } 
    // else {
    //     blocknavigation = ['/productselection'];
    // }
    // blocknavigation.forEach( pages => { 
    //         if(state.url === pages){ 
    //           this.router.navigate(['/home']);
    //           return false;
    //         }
    // });
    return true;
  }
}
